<script>
import { mapGetters } from "vuex";

export default {
  name: "is_verified",
  computed: {
    ...mapGetters(["getConfigJs"]),
  },
};
</script>

<template>
  <div
    v-if="
      !getConfigJs.isClosed &&
      !getConfigJs.isContinueChatEnabled &&
      getConfigJs.isVerified
    "
    class="flex text-xs items-center text-success font-italic gap-1"
  >
    <span class="material-symbols-outlined text-xs text-success">verified</span>
    <span>Verified</span>
  </div>
</template>

<style scoped></style>
